import { t } from 'i18next';
import { ObjectSchema } from 'yup';
import { PhoneCountryCodeType } from '@bus/models';
import { getEnumValues } from '../../../../services/common/miscUtils';
import Yup, { regExEmail, minMobileNumberLength, maxMobileNumberLength } from '../../../../services/common/validation';
import { NoYesEnum } from '../../../../types/forms';
import { BusinessCustomerTypesEnum } from '../../CustomerDataPage/customerDataPage.model';
import { BusinessProspectFormModel } from './formModel';

export const businessProspectFormSchema = (): ObjectSchema<BusinessProspectFormModel> => {
  return Yup.object({
    businessCustomerType: Yup.string().requiredWithMsg().oneOf(getEnumValues(BusinessCustomerTypesEnum)),
    legalName: Yup.string().requiredWithMsg().unaccentedLettersWithDigits().lengthBetween(0, 64),
    email: Yup.string().required(t('validation:required')).matches(regExEmail, t('validation:invalidEmail')),
    mobileNumber: Yup.string().requiredWithMsg().lengthBetween(minMobileNumberLength, maxMobileNumberLength),
    countryCode: Yup.string().requiredWithMsg().oneOf(getEnumValues(PhoneCountryCodeType)),
    storeQuoteTwelveMonths: Yup.mixed<NoYesEnum>()
      .oneOf(Object.values(NoYesEnum), t('validation:required'))
      .required(t('validation:required')),
  });
};
